import {Component, Vue, Watch} from 'vue-property-decorator'
import {DeviceType} from "@/store/modules/app";

const WIDTH = 992 // refer to Bootstrap's responsive design

@Component({
  name: 'ResizeMixin'
})
export default class extends Vue {
  get device() {
    return this.$store.getters['app/device'];
  }

  get sidebar() {
    return this.$store.getters['app/sidebar'];
  }

  @Watch('$route')
  private onRouteChange() {
    if (this.device === DeviceType.Mobile && this.sidebar.opened) {
      this.$store.dispatch('app/closeSidebar', false)
    }
  }

  beforeMount() {
    window.addEventListener('resize', this.resizeHandler)
  }

  mounted() {
    const isMobile = this.isMobile()
    if (isMobile) {
      this.$store.dispatch('app/toggleDevice', DeviceType.Mobile)
      this.$store.dispatch('app/closeSidebar', true)
    }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  private isMobile() {
    const rect = document.body.getBoundingClientRect()
    return rect.width - 1 < WIDTH
  }

  private resizeHandler() {
    if (!document.hidden) {
      const isMobile = this.isMobile();
      this.$store.dispatch('app/toggleDevice', isMobile ? DeviceType.Mobile : DeviceType.Desktop)
      if (isMobile) {
        this.$store.dispatch('app/closeSidebar', true)
      }
    }
  }
}
